import Button from '@sportnet/ui/lib/Button';
import Header from '@sportnet/ui/lib/Header';
import Modal, { ModalActions, ModalContent } from '@sportnet/ui/lib/Modal';
import { isAfter } from 'date-fns';
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { submit } from 'redux-form';
import HobbyApi from '../../api/HobbyApi';
import config from '../../config';
import { CustomThunkDispatch } from '../../configureStore';
import { Tournament } from '../../library/Tournament';
import useWindowSize from '../../utilities/resizeHook';
import __ from '../../utilities/__';
import RejectionForm from './rejectForm';

const REJECTION_FORM_NAME = 'REJECTION_FORM';

interface OwnProps {
  reloadTournament: () => void;
  invitationId: string;
  tournament: Tournament;
}

const TournamentInvitationStatusChange: React.FC<
  OwnProps & { dispatch: CustomThunkDispatch }
> = ({ dispatch, invitationId, tournament, reloadTournament }) => {
  const resizeHook = useWindowSize();

  const [mobileLayout, setMobileLayout] = React.useState(
    window.innerWidth < 600,
  );
  const [isAccepting, setIsAccepting] = React.useState(false);
  const [isRejecting, setIsRejecting] = React.useState(false);
  const [isRejectionModalOpened, setRejectionModalOpened] = React.useState(
    false,
  );

  React.useEffect(() => {
    if (resizeHook.innerWidth < 600) {
      setMobileLayout(true);
    } else {
      setMobileLayout(false);
    }
  }, [resizeHook.innerWidth]);

  const rejectInvitation = (values: { note: string }) => {
    changeStatus('REJECTED', values.note);
  };

  const changeStatus = async (
    status: 'ACCEPTED' | 'REJECTED',
    note?: string,
  ) => {
    const body: { status: 'ACCEPTED' | 'REJECTED'; note?: string } = { status };
    if (status === 'ACCEPTED') {
      setIsAccepting(true);
    } else if (status === 'REJECTED') {
      setIsRejecting(true);
      body.note = note;
    }
    try {
      await HobbyApi.updateTournamentInvitationStatus(
        config.APP_SPACE,
        tournament._id,
        invitationId,
        {},
        body,
      );
      reloadTournament();
    } catch (e) {
      alert(__('Nepodarilo sa zmeniť stav pozvánky'));
    } finally {
      setIsAccepting(false);
      setIsRejecting(false);
    }
  };

  const toggleRejectionModal = () => {
    setRejectionModalOpened(!isRejectionModalOpened);
  };

  const buttonsDisabled = isAccepting || isRejecting;
  const startDateIsDue = isAfter(new Date(), new Date(tournament.dateFrom));
  const registrationDateIsDue =
    tournament.registrationDueDate &&
    isAfter(new Date(), new Date(tournament.registrationDueDate));

  return (
    <>
      {!startDateIsDue && !registrationDateIsDue && (
        <>
          {mobileLayout ? (
            <>
              <div>
                <Button
                  loading={isRejecting}
                  disabled={buttonsDisabled}
                  onClick={toggleRejectionModal}
                  block
                  danger
                >
                  {__('Odmietnuť pozvánku')}
                </Button>
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'right' }}>
              <Button
                loading={isRejecting}
                disabled={buttonsDisabled}
                onClick={toggleRejectionModal}
                danger
              >
                {__('Odmietnuť pozvánku')}
              </Button>
            </div>
          )}
        </>
      )}
      <Modal
        size="s"
        centered
        handleClose={toggleRejectionModal}
        isOpen={isRejectionModalOpened}
      >
        <ModalContent>
          <Header size="xs" withSeparator>
            {__('Odmietnutie pozvánky')}
          </Header>
          <RejectionForm
            onSubmit={rejectInvitation}
            form={REJECTION_FORM_NAME}
          />
        </ModalContent>
        <ModalActions>
          <div>&nbsp;</div>
          <div>
            <Button onClick={toggleRejectionModal}>{__('Zrušiť')}</Button>
            &nbsp;
            <Button
              loading={isRejecting}
              onClick={() => {
                dispatch(submit(REJECTION_FORM_NAME));
              }}
              primary
            >
              {__('Potvrdiť')}
            </Button>
          </div>
        </ModalActions>
      </Modal>
    </>
  );
};

export default compose(connect())(TournamentInvitationStatusChange);
